module.exports = __webpack_public_path__ + "4cbad7fa1b55677a462fe7fb6d983a06.svg";